import React from "react";

export default function PremiumBikeWashHybridCoat() {
  return (
    <div className="space-y-2 text-sm text-gray-800">
      <p className="font-semibold">Includes:</p>
      <ul className="list-disc text-black-500 ">
        <li>Hybrid Ceramic Coating</li>
        <li>Tyre Polish</li>
        <li>Full Body Shine Coat</li>
        <li>High Pressure Foam Wash</li>
      </ul>
      
    </div>
  );
}


